import instructRequest from "instruct-request";
import axios from "axios";
const targetInstructRequest = instructRequest.create({
    baseURL: 'https://bizconfstreaming.yunkust.com/',
    method: 'POST'
}, axios);
export default targetInstructRequest;
